"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditorControlBar = exports.editorStyleVars = void 0;

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _netlifyCmsUiDefault = require("netlify-cms-ui-default");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const editorStyleVars = {
  stickyDistanceBottom: '100px'
};
exports.editorStyleVars = editorStyleVars;
const EditorControlBar = (0, _styledBase.default)("div", {
  target: "eqipg3b0",
  label: "EditorControlBar"
})("z-index:", _netlifyCmsUiDefault.zIndex.zIndex200, ";position:sticky;top:0;margin-bottom:", editorStyleVars.stickyDistanceBottom, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBTzBDIiwiZmlsZSI6Ii4uLy4uL3NyYy9zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyB6SW5kZXggfSBmcm9tICduZXRsaWZ5LWNtcy11aS1kZWZhdWx0JztcblxuZXhwb3J0IGNvbnN0IGVkaXRvclN0eWxlVmFycyA9IHtcbiAgc3RpY2t5RGlzdGFuY2VCb3R0b206ICcxMDBweCcsXG59O1xuXG5leHBvcnQgY29uc3QgRWRpdG9yQ29udHJvbEJhciA9IHN0eWxlZC5kaXZgXG4gIHotaW5kZXg6ICR7ekluZGV4LnpJbmRleDIwMH07XG4gIHBvc2l0aW9uOiBzdGlja3k7XG4gIHRvcDogMDtcbiAgbWFyZ2luLWJvdHRvbTogJHtlZGl0b3JTdHlsZVZhcnMuc3RpY2t5RGlzdGFuY2VCb3R0b219O1xuYDtcbiJdfQ== */"));
exports.EditorControlBar = EditorControlBar;